import APIconsume from './APIconsume'
class LoginService {
    constructor(){
        this._consume = new APIconsume()
        this._path = '/auth/login'
        this._requestTokenPath = '/auth/key'
        this._pathCheck = '/auth/verified'
    }

    async checkAccounts(customerId) {
        const payload = {
            customerId
        }

        const result = await this._consume.postData(payload, this._pathCheck)
        return result.data
    }

    async requestToken(customerId, Password) {
        const payload = {
            customerId,
            Password
        }

        const result = await this._consume.postData(payload, this._requestTokenPath)
        return result.data
    }

    async login(usrIdentifier, key, otp) {
        const payload = {
            usrIdentifier, key, otp
        }

        const result = await this._consume.postData(payload, this._path)
        return result.data
    }

   async verifyLoginPayload (customerId, pass) {
        if (customerId.length === 0 && pass.length === 0) {
            throw new Error('CustomerId and Password Required')
        } else if (customerId.length === 0) {
            throw new Error('CustomerId Required')
        } else if (pass.length === 0) {
            throw new Error('CustomerId Required')
        }
    }
}



export default LoginService